import { FC, LabelHTMLAttributes } from "react";
import classNames from "classnames";

export const EvoFieldLabel: FC<LabelHTMLAttributes<HTMLLabelElement>> = ({
  className,
  children,
  ...rest
}) => (
  <label className={classNames("text-xs font-medium text-evo-muted", className)} {...rest}>
    {children}
  </label>
);
